import axios from 'axios';

import {
	getAccessToken,
	getSelectedAccountNumber,
	getSessionTimeLeft,
} from 'core/browserStorage';
import { isInvalidLocalStorage } from 'core/utils/global-utils';

/**
 * Axios-based data fetcher for Sitecore JSS Layout Service and other APIs.
 * @param {string} url - The request URL
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise<any>} - Resolves with response data or rejects with error
 */

export async function dataFetcher(url, options = {}) {
	try {
		const method = options.method ?? 'get';
		const data = options.body ?? undefined;
		const params = options.params ?? {};
		const headers = options.headers ?? {};

		const isDevelopmentEnv =
			typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
		const accessToken = getAccessToken();

		const selectedAccountNumber = getSelectedAccountNumber();
		const sessionTimeLeft = getSessionTimeLeft();

		const validatedSessionTimeLeft = isInvalidLocalStorage(sessionTimeLeft)
			? null
			: { sessionTimeLeft };

		const validatedAccountNumber = isInvalidLocalStorage(selectedAccountNumber)
			? null
			: { selectedAccountNumber };

		const response = await axios({
			url,
			method,
			params,
			headers: accessToken
				? {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${accessToken}`,
						...validatedAccountNumber,
						...validatedSessionTimeLeft,
						...headers,
				  }
				: {},
			withCredentials: !isDevelopmentEnv,
			data: data ? JSON.stringify(data) : undefined,
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			throw error.response;
		}
		throw error;
	}
}
